module.exports = __webpack_public_path__ + "img/messenger-instruction-3.45a9c780.png";